"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _courseWrapper = _interopRequireDefault(require("./courseWrapper.png"));
var _Mediator = _interopRequireDefault(require("./Mediator"));
var _Settings = _interopRequireDefault(require("./Settings"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*
 * WARNING: DO NOT MOVE THIS FILE
 *
 * Its location is referenced directly from within an app because the search
 * for navigations occurs BEFORE the export in Root.js.
 *
 * To use this mediator in your app, import as follows:
 *
 * import courseWrapper from 'cccisd-laravel-assignment/dist/components/navigations/courseWrapper';
 */
var _default = {
  handle: 'courseWrapper',
  label: 'Course Wrapper',
  thumbnail: _courseWrapper["default"],
  mediatorComponent: _Mediator["default"],
  settingsComponent: _Settings["default"]
};
exports["default"] = _default;